import { ChangeDetectorRef, Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { coerceBooleanProperty, BooleanInput} from '@angular/cdk/coercion';

@Directive({
	selector: '[appToggle]',
	exportAs: 'appToggle'
})
export class ToggleDirective {
	// for template type checking
	public static ngAcceptInputType_active: BooleanInput;
	
	private _active = false;
	
	// eslint-disable-next-line @angular-eslint/no-output-rename
	@Output('appToggleChange')
	public readonly activeChange = new EventEmitter<boolean>();
	
	@Input('appToggle')
	public set active(value: boolean){
		this._active = coerceBooleanProperty(value);
		this.activeChange.emit(value);
	}	
	public get active(): boolean{
		return this._active;
	}
	
	constructor(private readonly cdr: ChangeDetectorRef) {}
	
	@HostListener('click')
	public toggle(): void{
		this.active = !this.active;
		this.cdr.markForCheck();
	}
}
